import React, { useEffect, useState } from 'react';
import NavBars from '../Sidebar/Sidebar';
import './protected.css';
import { db } from '../../firebase'; // Import Firebase config
import { collection, getDocs, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore'; // Import necessary Firestore functions
import Popup from 'reactjs-popup';
import { FaPlus, FaEdit } from 'react-icons/fa';
import { UserAuth, fetchAdminPassword } from '../../authContext';
const Tools = () => {
  const [tools, setTools] = useState([]);
  const [showNewToolModal, setShowNewToolModal] = useState(false); // State to toggle new tool modal visibility
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTool, setSelectedTool] = useState(null); // State to store the tool to be edited
  const [isAdmin, setIsAdmin] = useState(false);
  const { user } = UserAuth();
  useEffect(() => {
      const checkAdminStatus = async () => {
          try {
              // Simulate a delay to fetch user info
              const storedUser = JSON.parse(localStorage.getItem('user'));
              const storedIsAdmin = localStorage.getItem('isAdmin') === 'true';

              if (storedUser && storedUser.email === user?.email) {
                  setIsAdmin(storedIsAdmin);
              } else {
                  setIsAdmin(false);
              }
          } catch (error) {
              console.error("Failed to fetch admin status:", error);
              setIsAdmin(false);
          } 
      };
      if (user) {
        checkAdminStatus();
    } 
}, [user]);
  useEffect(() => {
    const fetchData = async () => {
      // Fetch tools from the "tools" collection in Firebase
      const toolsCollection = collection(db, 'Tools');
      const toolsSnapshot = await getDocs(toolsCollection);
      const toolsList = toolsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setTools(toolsList);
    };

    fetchData();
  }, []);

  const handleNewToolClick = async(tool) => {
    setShowNewToolModal(true);
  };

  const addNewTool = async ({ name, image, isAvailable }) => {
    try {
        if (!name || !image) {
            alert('Please fill out all required fields.');
            return;
        }

        await addDoc(collection(db, 'Tools'), {
            Name: name,
            image,
            isAvailable // Use isAvailable instead of TotalQuantity
        });

        setTools(prevTools => [
            ...prevTools,
            { Name: name, image, isAvailable } // Use isAvailable here too
        ]);
        setShowNewToolModal(false);
        window.location.reload();
    } catch (error) {
        console.error('Error adding new tool:', error);
    }
};


  const handleEditToolClick = async(tool) => {
          setSelectedTool(tool);
          setShowEditModal(true);
  };

  const handleDeleteToolClick = async (toolId) => {
    const confirmDelete = window.confirm("Are you sure you want to remove this tool?");
            if (confirmDelete) {
    try {
      await deleteDoc(doc(db, 'Tools', toolId));
      setTools(prevTools => prevTools.filter(tool => tool.id !== toolId));
      setShowEditModal(false);
    } catch (error) {
      console.error('Error deleting tool:', error);
    }
    }
  };

  const editTool = async (toolId, name, image, isAvailable) => {
    try {
        const toolDocRef = doc(db, 'Tools', toolId);
        await updateDoc(toolDocRef, {
            Name: name,
            image,
            isAvailable // Use isAvailable here instead of TotalQuantity
        });
        setTools(prevTools =>
            prevTools.map(tool =>
                tool.id === toolId
                    ? { ...tool, Name: name, image, isAvailable } // Update isAvailable here
                    : tool
            )
        );
        setShowEditModal(false);
    } catch (error) {
        console.error('Error updating tool:', error);
    }
};


  return (
    <div>
      <div className='content'>
        <div className='grid-container'>
          {tools.length ? (
            tools.map(tool => (
              <div key={tool.id} className='item' onDoubleClick={isAdmin ? () => handleEditToolClick(tool):null}>
                <h2 className='item-name'>{tool.Name}</h2>
                <img className='field' src={tool.image} alt={tool.Name} style={{ width: 'auto', height: '140px' }} />
                <p className='field'>
                  {tool.TotalQuantity > 0 ? 'Available' : 'Not available'}
                </p>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
          { isAdmin && <button 
                      className="floating-button"                       
                        onClick={handleNewToolClick}
                    >
                      <FaPlus style={{ color: 'white' }} />
                    </button>}
        </div>
        
        <Popup open={showNewToolModal} onClose={() => setShowNewToolModal(false)}>
          <div className="modal">
            <h2>Add New Tool</h2>
            <NewToolForm onSubmit={addNewTool} onCancel={() => setShowNewToolModal(false)} />
          </div>
        </Popup>
        <Popup open={showEditModal} onClose={() => setShowEditModal(false)}>
          <div className="modal">
            <h2>Edit Tool</h2>
            <EditToolForm
              tool={selectedTool}
              onSubmit={editTool}
              onDelete={() => handleDeleteToolClick(selectedTool.id)}
              onCancel={() => setShowEditModal(false)}
            />
          </div>
        </Popup>
      </div>
      <NavBars />
    </div>
  );
};

const NewToolForm = ({ onSubmit, onCancel }) => {
    const [name, setName] = useState('');
    const [image, setImage] = useState('');
    const [isAvailable, setIsAvailable] = useState(true); // Default to true
    const [documentation, setDocumentation] = useState('');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit({ name, image, isAvailable, documentation });
    };
  
    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className='form-comp'>Name:</label>
          <input className='form-comp' type="text" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="form-group">
          <label className='form-comp'>Image URL:</label>
          <input className='form-comp' type="text" value={image} onChange={(e) => setImage(e.target.value)} />
        </div>
        <div className="form-group">
          <label className='form-comp'>Available:</label>
          <select className='form-comp' value={isAvailable} onChange={(e) => setIsAvailable(e.target.value === 'true')}>
            <option value={true}>Available</option>
            <option value={false}>Not Available</option>
          </select>
        </div>
        <div className="form-group">
          <label className='form-comp'>Documentation:</label>
          <input className='form-comp' value={documentation} onChange={(e) => setDocumentation(e.target.value)} />
        </div>
        <button type="submit" className='modal-button'>Add Tool</button>
        <button type="button" className='modal-button' onClick={onCancel}>Cancel</button>
      </form>
    );
  };
  

  const EditToolForm = ({ tool, onSubmit, onDelete, onCancel }) => {
    const [name, setName] = useState(tool?.Name || '');
    const [image, setImage] = useState(tool?.image || '');
    const [isAvailable, setIsAvailable] = useState(tool?.isAvailable || true); // Default to true
    const [documentation, setDocumentation] = useState(tool?.Documentation || '');
  
    const handleSubmit = (e) => {
      e.preventDefault();
      onSubmit(tool.id, name, image, isAvailable, documentation);
    };
  
    return (
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Name:</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Image URL:</label>
          <input type="text" value={image} onChange={(e) => setImage(e.target.value)} />
        </div>
        <div className="form-group">
          <label>Available:</label>
          <select value={isAvailable} onChange={(e) => setIsAvailable(e.target.value === 'true')}>
            <option value={true}>Available</option>
            <option value={false}>Not Available</option>
          </select>
        </div>
        <div className="form-group">
          <label>Documentation:</label>
          <input value={documentation} onChange={(e) => setDocumentation(e.target.value)} />
        </div>
        <button type="submit" className='modal-button'>Save Changes</button>
        <button type="button" className='modal-button' onClick={onCancel}>Cancel</button>
        <button type="button" className='modal-button delete' onClick={onDelete}>Delete Tool</button>
      </form>
    );
  };
  

export default Tools;
